import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { CardView } from '@/features/tasks/CardView';

export const Route = createFileRoute('/_app/tasks/card')({ component: DetailView });

/**
 * La vista «Scheda» è **da scrivania**, e non è una mancanza.
 *
 * Sul telefono la scheda di un task è già una schermata intera (`/tasks/$taskId`): una vista
 * fatta di guida stretta più scheda larga, su 390 punti, sarebbe la stessa cosa con in più una
 * colonna che non ci sta. Per questo non compare in `mobileViews.ts` — e chi ci arriva per URL
 * non deve trovare un vicolo cieco: se un task è aperto si va alla sua schermata, altrimenti
 * all'elenco, che è il posto da cui si sceglie.
 */
function DetailView() {
  const isMobile = useIsMobileShell();
  const { task } = Route.useSearch();
  if (!isMobile) return <CardView />;
  return task
    ? <Navigate to="/tasks/$taskId" params={{ taskId: task }} replace />
    : <Navigate to="/tasks/list" replace />;
}
